import { lazy, type ComponentType } from 'react';

/**
 * Route-level code splitting: each import becomes its own async chunk.
 * Keeps the main bundle small; pages load only when navigated to.
 */

export const LandingPage = lazy(() => 
  import("../components/landing/LandingView").then(module => ({ default: module.LandingView }))
);

export const LazyChooseAccountType = lazy(() =>
  import('../sections/account-type/choose-account').then((m) => ({
    default: m.ChooseAccountType as ComponentType,
  }))
);

export const LazySelectTreatmentLine = lazy(() =>
  import('../sections/account-type/select-treatment-line').then((m) => ({
    default: m.SelectTreatmentLine as ComponentType,
  }))
);

// export const LazyBusinessOnboarding = lazy(() =>
//   import('../sections/business-information/BusinessFlow').then((m) => ({
//     default: m.default as ComponentType,
//   }))
// );


export const LazyBusinessOnboarding = lazy(() => 
  import('../sections/business-information/Business-Information').then((module) => ({ 
    default: module.BusinessOnboarding as ComponentType<any> 
  }))
);


// export const LazyServiceArea = lazy(() =>
//   import('../sections/business-information/ServiceAreaForm').then((m) => ({
//     default: m.default as ComponentType,
//   }))
// );

export const LazyServiceArea = lazy(() =>
  import('../sections/business-information/ServiceAreaForm')
);

export const LazyBillingIndividual = lazy(() =>
  import('../sections/Billing/BillingPage').then((m) => ({
    default: function BillingIndividual() {
      return <m.BillingPage type="individual" />;
    },
  }))
);

export const LazyBillingBusiness = lazy(() =>
  import('../sections/Billing/BillingPage').then((m) => ({
    default: function BillingBusiness() {
      return <m.BillingPage type="business" />;
    },
  }))
);

export const LazyBillingConfirm = lazy(() =>
  import('../sections/Billing/ConfirmPage')
);

export const LazyBillingSuccess = lazy(() =>
  import('../sections/Billing/SuccessPage')
);

export const LazySubscriptionPage = lazy(() =>
  import('../sections/Billing/SubscriptionPage')
);

export const LazySetupProfileStatus = lazy(() =>
  import('../sections/Dashboard/profileStatus')
);

export const LazyDashboard = lazy(() =>
  import('../sections/Dashboard/Dashboard')
);

export const LazyDashboardBookings = lazy(() =>
  import('../sections/Dashboard/Bookings')
);

export const LazyDashboardProviders = lazy(() =>
  import('../sections/Dashboard/providers')
);

export const LazyDashboardEarnings = lazy(() =>
  import('../sections/Dashboard/Earnings')
);

export const LazyDashboardSettingsBusinessProfile = lazy(() =>
  import("../sections/Dashboard/settings/BusinessProfile")
);

export const LazyDashboardSettingsBusinessProfileEdit = lazy(() =>
  import("../sections/Dashboard/settings/BusinessProfileEdit")
);

export const LazyDashboardSettingsPlaceholder = lazy(() =>
  import("../sections/Dashboard/settings/SettingsPlaceholder")
);

export const LazyDashboardSettingsNotifications = lazy(() =>
  import("../sections/Dashboard/settings/Notifications")
);

export const LazyDashboardSettingsSupport = lazy(() =>
  import("../sections/Dashboard/settings/Support")
);

export const LazyDashboardSettingsProviders = lazy(() =>
  import("../sections/Dashboard/settings/Providers")
);

export const LazyDashboardSettingsManageBookings = lazy(() =>
  import("../sections/Dashboard/settings/ManageBookings")
);

export const LazyDashboardSettingsSubscriptions = lazy(() =>
  import("../sections/Dashboard/settings/Subscriptions")
);

export const LazyDashboardSettingsCalendar = lazy(() =>
  import("../sections/Dashboard/settings/Calendar")
);

export const LazyDashboardSettingsLocation = lazy(() =>
  import("../sections/Dashboard/settings/Location")
);


export const LazyProviderTeam = lazy(() =>
  import('../sections/invite-provider/ProviderTeam').then((m) => ({
    default: m.ProviderTeam as ComponentType,
  }))
);

export const LazyMenuBuilder = lazy(() =>
  import(
    "../features/menu-builder/ui/screens/MenuBuilderScreen"
  )
);
export const LazyStripeFlow = lazy(() =>
  import(
    "../features/stripe-flow/ui/screens/StripeFlowScreen"
  )
);

export const LazyIndividualOnboarding =
  lazy(() =>
    import(
      "../features/individual-onboarding/ui/screens/IndividualOnboardingScreen"
    ).then((m) => ({
      default:
        m.IndividualOnboardingScreen as ComponentType,
    }))
  );

export const LazyIndividualProviderVerification =
  lazy(() =>
    import(
      "../features/individual-provider-verification/ui/screen/IndividualProviderVerificationScreen"
    ).then((m) => ({
      default:
        m.IndividualProviderVerificationScreen as ComponentType,
    }))
  );

  export const LazyClinicalLiveBookings = lazy(() =>
    import(
        "../features/clinical-live-bookings/ui/screens/ClinicalLiveBookingsScreen"
    )
);

export const LazyClinicalChecklist = lazy(() =>
    import(
        "../features/clinical-live-bookings/ui/screens/ClinicalChecklistScreen"
    )
);

export const LazyProviderReview = lazy(() =>
    import(
        "../features/clinical-live-bookings/ui/screens/ProviderReviewScreen"
    )
);

export const LazyIVMaterialsLogged = lazy(() =>
    import(
        "../features/clinical-live-bookings/ui/screens/IVMaterialsLoggedScreen"
    )
);

export const LazyVitalsRecorded = lazy(() =>
    import(
        "../features/clinical-live-bookings/ui/screens/VitalsRecordedScreen"
    )
);

export const LazyNonClinicalLiveBookings = lazy(() =>
    import(
        "../features/clinical-live-bookings/ui/screens/NonClinicalLiveBookingsScreen"
    )
);